import React from "react";
import { Clock, XCircle, CheckCircle, AlertTriangle } from "lucide-react";
import Icon from '../../../components/AppIcon';


const STATUS_CONFIG = {
  pending: { label: "Pending", bg: "#fdecd3", text: "#92400e", border: "#f3e8d0", Icon: Clock },
  rejected: { label: "Rejected", bg: "#fef2f2", text: "#b91c1c", border: "#fecaca", Icon: XCircle },
  live: { label: "Live", bg: "#e3f2ef", text: "#0f766e", border: "#bfe3dd", Icon: CheckCircle },
  expired: { label: "Expired", bg: "#fef2f2", text: "#9a3412", border: "#fed7aa", Icon: AlertTriangle },
};

const StatusBadge = ({ status }) => {
  const config = STATUS_CONFIG?.[status] || STATUS_CONFIG?.pending;
  const { label, bg, text, border, Icon } = config;

  return (
    <span
      className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-semibold"
      style={{ background: bg, color: text, border: `1px solid ${border}` }}
    >
      <Icon size={11} />
      {label}
    </span>
  );
};

export default StatusBadge;
